export default {"src":"/_next/static/media/lightningCloud_40.27a796af.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};